import axios from "axios";

// Notes (PDF/PPT) attached to a batch. Lives on the main domain because that
// is where the Bunny CDN credentials + `notes` table helpers are.
export const NOTES_ENDPOINT = "https://siliconmindstechnologies.com/";

const GetBatchNotes = async ({ payload }) => {
  const data = new FormData();
  data.append("session", payload.session);
  data.append("course_url", payload.course_url);
  data.append("batch_id", payload.batch_id);

  const res = await axios.post(NOTES_ENDPOINT + "get-batch-notes.php", data, {
    headers: { "content-type": "multipart/form-data" },
  });
  return res ? res.data : null;
};

export default GetBatchNotes;
